import script from "./PecTutor.vue?vue&type=script&setup=true&lang=ts"
export * from "./PecTutor.vue?vue&type=script&setup=true&lang=ts"

import "./PecTutor.vue?vue&type=style&index=0&id=ff1b8952&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff1b8952"]])

export default __exports__